import React from 'react'
import CommentIcon from '@mui/icons-material/Comment';
import { Tooltip } from '@mui/material'

const SupplyBillCommentsShort = ({ comments }) => {
  return (
    <div className='commentShortOne'>
        <Tooltip title='Коментарів'>
            <CommentIcon />
        </Tooltip>
        <p>
            {
                comments ? comments.length : ''
            }
        </p>
    </div>
  )
}

export default SupplyBillCommentsShort